export function findConfigurationAttachments(attachments, tag) {
    return Object.values(attachments).filter((attachment) => { var _a; return (_a = attachment.tags) === null || _a === void 0 ? void 0 : _a.includes(tag); });
}
//# sourceMappingURL=findConfigurationAttachments.js.map